import { api } from './api';

// Define a service using a base URL and expected endpoints
export const metadataApi = api.injectEndpoints({
  reducerPath: 'metadataApi',
  tagTypes: ['propertyTypes', 'entityTypes'],
  endpoints: (builder) => ({
    getAllEntityTypes: builder.query({
      query: () => ({
        url: 'public/api/metadata/entityTypes',
        method: 'GET'
      }),
      providesTags: (result) =>
        result && result.rows
          ? [...result.rows.map(({ id }) => ({ type: 'entityTypes', id }))]
          : ['entityTypes']
    }),
    getAllPropertyTypes: builder.query({
      query: () => ({
        url: 'public/api/metadata/propertyTypes',
        method: 'GET'
      }),
      providesTags: (result) =>
        result && result.rows
          ? [...result.rows.map(({ id }) => ({ type: 'propertyTypes', id }))]
          : ['propertyTypes']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllEntityTypesQuery, useGetAllPropertyTypesQuery } = metadataApi;
